// src/api.js
const API_BASE = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

export class ApiAuthError extends Error {
  constructor(message = "Non autorisé") {
    super(message);
    this.name = "ApiAuthError";
    this.status = 401;
  }
}

export function apiUrl(path) {
  if (!path) return API_BASE || "/";
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
}

export async function apiLogin(username, password) {
  const res = await fetch(apiUrl("/api/login"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || "Identifiants invalides");
    err.status = res.status;
    throw err;
  }
  return data;
}

export async function apiFetch(url, options = {}) {
  const { skipAuthRedirect = false, ...fetchOptions } = options;
  const token = localStorage.getItem("authToken");

  const headers = {
    ...(fetchOptions.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  const res = await fetch(apiUrl(url), { ...fetchOptions, headers });

  // Gestion du 401 = token invalide / expiré
  if (res.status === 401) {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    if (!skipAuthRedirect && window.location.pathname !== "/") {
      window.location.href = "/";
    }
    throw new ApiAuthError("Non autorisé");
  }

  return res;
}
